export const flatten = (items = []) => {
  if (items.length === 0) {
    return [];
  }

  const [item, ...rest] = items;
  if (Array.isArray(item)) {
    return [...flatten(item), ...flatten(rest)];
  }

  if (typeof item === 'string') {
    return [item.trim(), ...flatten(rest)];
  }

  return [item, ...flatten(rest)];
};

export const flattenWithoutComma = (items = []) => {
  const __items = flatten(items || []);
  const ___items = flatten(__items.map((item) => `${item}`.split(',')));
  return ___items;
};
